<template>
	<a-layout class="admin-layout">
		<a-layout-header class="admin-header-wrapper">
      <div class="admin-header-content">
        <div class="logo"><img :src="filePreview(logoId)"/></div>
        <a-menu
            class="menu"
            theme="dark"
            mode="horizontal"
            :default-selected-keys="[this.$route.matched[1].name]"
            :style="{ lineHeight: '60px', height: '60px' }"
        >
          <a-menu-item v-show="false" @click="handleMenuClick" key="AdminHome"><img :src="require('@/assets/admin/icon-home.svg')" />首页</a-menu-item>
          <a-menu-item @click="handleMenuClick" key="ContactsAdminIndex"><img class="icon-ad" :src="require('@/assets/admin/icon-addresss.png')" />通讯录</a-menu-item>
          <a-menu-item @click="handleMenuClick" key="AppCenter"><img class="icon-ap" :src="require('@/assets/admin/icon-applys.png')" />应用中心</a-menu-item>
          <a-menu-item @click="handleMenuClick" key="NavigationManage"><img class="icon-na" :src="require('@/assets/admin/icon-navigation.png')" />导航页管理</a-menu-item>
          <a-menu-item @click="handleMenuClick" key="CompanyAdminView"><img class="icon-cm" :src="require('@/assets/admin/icon-config.png')" />配置中心</a-menu-item>
        </a-menu>
        <a-dropdown>
          <div class="avatar-admin">
            <zjy-avatar :url="$store.getters.userInfo.avatar" :name="$store.getters.name"/>
            {{ $store.getters.name }}<a-icon type="caret-down" />
          </div>
          <a-menu slot="overlay" class="admin-user-dropdown">
	          <a-menu-item key="1" @click="handleWorkbenchClick">
		          <a-icon type="home" />
		          <span>工作台</span>
	          </a-menu-item>
            <a-menu-item key="1" @click="handleLogoutClick">
              <a-icon type="logout"/>
              <span>退出登录</span>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
		</a-layout-header>
		<a-layout-content :style="{ padding: '24px'}" class="admin-body-wrapper">
			<div class="admin-body-content">
				<router-view/>
			</div>
		</a-layout-content>
<!--		<a-layout-footer :style="{ textAlign: 'center' }">-->
<!--			Ant Design ©2018 Created by Ant UED-->
<!--		</a-layout-footer>-->
	</a-layout>
</template>

<script>

import {getCompanySetting} from "@/api/config";
import ZjyAvatar from "@/components/zjy/ZjyAvatar.vue";
export default {
	name: "AdminLayout",
  components: { ZjyAvatar },
	data() {
		return {
			name: undefined,
			logoId: undefined,
		};
	},
	methods: {
		handleWorkbenchClick() {
			this.$router.push({name: 'WorkHomeIndex'})
		},
		handleLogoutClick() {
			this.$confirm({
				title: '提示',
				content: '真的要注销登录吗 ?',
				okText: '确定',
				cancelText: '取消',
				onOk: () => {
					this.$store.dispatch('Logout').then(() => {
						location.reload()
					})
				},
				onCancel () {
				}
			})
		},
		getCompanySetting() {
			getCompanySetting().then(res => {
				if (res.success) {
					this.name = res.data.unitName;
					this.logoId = res.data.logo;
				}
			})
		},
		handleMenuClick({key}) {
			this.$router.push({name: key})
		}
	},
	created() {
		this.getCompanySetting()
	}
}
</script>

<style scoped lang="less">
.admin-layout {
  height: 100vh;
  //background: #e8e9eb;
  background: #e9eced;
  min-width: 1024px;
	.admin-header-wrapper {
    height: 60px;
    line-height: 60px;
    background: #fff;
    box-shadow: 0 2px 16px 0 rgba(31, 35, 41, .05);
    padding: 0 20px;
    .admin-header-content {
      display: flex;
      flex-direction: row;
      max-width: 1366px;
      margin: 0 auto;
    }
    .logo {
      margin-right: 60px;
      padding: 10px 0;
      height: 60px;
      img {
        height: 40px;
        vertical-align: top;
      }
    }
    .avatar-admin {
      cursor: pointer;
      .avatar {
        width: 40px;
        display: inline-block;
      }
      .anticon {
        margin-left: 12px;
      }
    }
	}
	.menu {
		display: flex;
		flex: 1;
    background-color: #fff;
    font-size: 16px;
    .ant-menu-item{
      margin-right: 35px;
      color: #333345;
      transition: none;
      .icon-ap {
        vertical-align: -2.5px;
      }
      &:hover, &-selected  {
        color: #3e7dff;
        .icon-ad {
          content: url("@/assets/admin/icon-addresss-blue.png");
        }
        .icon-ap {
          content: url("@/assets/admin/icon-applys-blue.png");
        }
        .icon-cm {
          content: url("@/assets/admin/icon-config-blue.png");
        }
        .icon-na {
          content: url("@/assets/admin/icon-navigation-blue.png");
        }
      }
      img {
        vertical-align: -2px;
        margin-right: 8px;
      }
    }
    .ant-menu-item-selected {
      background: rgb(245,248,255);
    }
	}
  .admin-body-wrapper {
    overflow: auto;
    flex: 1;
    .admin-body-content {
      background: #fff;
      border-radius: 6px;
      max-width: 1366px;
      //min-height: 100%;
      height: 100%;
      margin: 0 auto;
      display: flex;
      overflow: hidden;
    }
  }
}

</style>
